import { makeLogger } from "@/shared/consola";
import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const logger = makeLogger("player-stats.service");

const makeStatsEndpoint = (playerUUID) => `players/${playerUUID}/stats`;

export const playerStatsService = {
    async getSummaryForStudents(playerUUID, { dateRange } = {}) {
        logger.trace("getSummaryForStudents fired");
        return ajaxCall
            .get(`${makeStatsEndpoint(playerUUID)}/summary/students`, { params: { dateRange } })
            .catch(handleErrorByMessage());
    },
    async getSummaryForLessons(playerUUID) {
        logger.trace("getSummaryForLessons fired");
        return ajaxCall
            .get(`${makeStatsEndpoint(playerUUID)}/summary/lessons`)
            .catch(handleErrorByMessage());
    },

    async getStudents(playerUUID, { page, size, dateRange, search } = { page: 1, size: 100 }) {
        logger.trace("getStudents fired");
        return ajaxCall
            .get(`${makeStatsEndpoint(playerUUID)}/students`, {
                params: { page, size, dateRange, search },
            })
            .catch(handleErrorByMessage());
    },

    async getLessons(playerUUID) {
        logger.trace("getLessons fired");
        return ajaxCall
            .get(`${makeStatsEndpoint(playerUUID)}/lessons`)
            .catch(handleErrorByMessage());
    },

    async getLessonsProgressForStudent(playerUUID, studentUUID) {
        logger.trace("getLessonsProgressForStudent fired");
        return ajaxCall
            .get(`${makeStatsEndpoint(playerUUID)}/lessons/by-student/${studentUUID}`)
            .catch(handleErrorByMessage());
    },

    // Calls to gather statistics (INPUTs):

    async markLessonCompletion(playerUUID, lessonId, done = true) {
        logger.trace("markLessonCompletion fired");
        return ajaxCall
            .patch(`${makeStatsEndpoint(playerUUID)}/lessons/${lessonId}`, { done })
            .catch(handleErrorByMessage({ rethrow: false }));
    },

    async recordVisit(playerUUID) {
        logger.trace("markLessonCompletion fired");
        return ajaxCall
            .post(`${makeStatsEndpoint(playerUUID)}/visited`, {})
            .catch(handleErrorByMessage({ rethrow: false }));
    },
};
